import React from "react";
import ReactDOM from "react-dom/client";
import { createHashRouter, RouterProvider } from "react-router-dom";
import { initializeIcons } from "@fluentui/react";
import { MsalProvider as MSALProvider } from "@azure/msal-react";
import { MsalProvider } from "./MsalContext";
import { GlobalProvider } from "./GlobalContext";
import { Navigate } from "react-router-dom";

import "./index.css";

import Layout from "./pages/layout/Layout";
import ProductsLanding from "./pages/layout/ProductsLanding";
import Chat from "./pages/chat/Chat";

try {
    initializeIcons();
} catch (e) {
    import.meta.env.DEV === true && console.log("‹errr_ico›", e);
}

const subPath = import.meta.env.VITE_INFO_SUB || "/details";
const router = createHashRouter([
    {
        path: "*",
        element: window.location.pathname?.toLowerCase().startsWith(subPath) == false ? <Layout /> : <ProductsLanding />,
        children: [
            {
                index: true,
                element: <Chat />
            },
            {
                path: "*",
                element: <Chat />
            }
        ]
    }
]);

ReactDOM.createRoot(document.getElementById("root") as HTMLElement).render(
    <GlobalProvider>
        <MsalProvider>
            <RouterProvider router={router} />
        </MsalProvider>
    </GlobalProvider>
)
